import {
  filterAssetsByLocale,
  getAssetByTags,
  getAssetsByTags,
  getAttribute,
  getProductAssets,
  getVariantFinalPrice,
  isVariantActive,
  sortAndDedupeFacets,
  sortAssetsByPriority,
} from './product.util'

export function createFitnessViewModel(args: {
  productData: Commercetools.ProductData
  builderContent: any
  locale: string
}): FitnessViewModel {
  filterAssetsByLocale(args.productData, args.locale)
  const productAssets = sortAssetsByPriority(getProductAssets(args.productData))
  const variants = [args.productData.masterVariant]
    .concat(args.productData.variants)
    .map(createFitnessVariant)
    .filter(isVariantActive)
  const masterVariant = variants[0]

  return {
    product: {
      ...args.productData,
      productType: args.productData.productType?.obj?.key ?? '',
      productSubtype: getAttribute(masterVariant, 'productSubtype'),
      productShortDescription: getAttribute(masterVariant, 'productShortDescription'),
      productSeoDescription: getAttribute(masterVariant, 'productSeoDescription'),
      productDirections: getAttribute(masterVariant, 'productDirections'),
      productFeaturedIngredients: getAttribute(masterVariant, 'productFeaturedIngredients'),
      assets: productAssets,
    },
    variants,
    masterVariant,
    selectedVariant: masterVariant,
    accolades: args?.builderContent?.data?.accolades ?? [],
    socialProof: args?.builderContent?.data?.socialProof ?? [],
    alternateProducts: args?.builderContent?.data?.alternateProducts ?? [],
    facetOptions: getFitnessFacetOptions(variants),
    quantity: 1,
  }
}

/** Creates a fitness variant from a product variant */
function createFitnessVariant(variant: Commercetools.ProductVariant): FitnessVariant {
  return {
    ...variant,
    assets: sortAssetsByPriority(getAssetsByTags(variant, ['type:sku'])),
    originalPrice: variant.prices?.[0]?.value?.centAmount ?? 0,
    finalPrice: getVariantFinalPrice({ variant }),
    facets: {
      size: {
        slug: getAttribute(variant, 'sizeSlug'),
        displayName: getAttribute(variant, 'sizeDisplayName'),
        priority: getAttribute(variant, 'sizePriority'),
        descriptor: getAttribute(variant, 'sizeDescriptor'),
        imagePrimary: getAssetByTags(variant, [
          'type:facet',
          `size:${getAttribute(variant, 'sizeSlug')}:primary`,
        ]),
        imageSecondary: getAssetByTags(variant, [
          'type:facet',
          `size:${getAttribute(variant, 'sizeSlug')}:secondary`,
        ]),
      },
    },
  }
}

/** Creates facet options for the fitness product */
function getFitnessFacetOptions(variants: FitnessVariant[]): FitnessFacetOptions {
  return {
    size: sortAndDedupeFacets({ variants, facetKey: 'size' }),
  }
}
